import React, { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import WebsiteManagement from './WebsiteManagement';
import WebsiteSubscription from './WebsiteSubscription';
import websiteSubscriptionService from '../../services/websiteSubscriptionService';

const WebsiteWrapper = () => {
  const { user } = useAuth();
  const [subscriptionStatus, setSubscriptionStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showSuccess, setShowSuccess] = useState(false);

  useEffect(() => {
    checkSubscriptionStatus();
  }, [user]);

  const checkSubscriptionStatus = async () => {
    try {
      setLoading(true);
      setError(null);

      // Debug logging
      console.log('🔍 WebsiteWrapper - User object:', user);
      console.log('🔍 WebsiteWrapper - User role:', user?.role);
      console.log('🔍 WebsiteWrapper - User agency_id:', user?.agency_id);
      console.log('🔍 WebsiteWrapper - User website_subscription_active:', user?.website_subscription_active);

      // Check if user should have automatic access (independent agents, admins)
      if (user.role === 'independent_agent' || 
          user.role === 'super_admin' || 
          user.role === 'agency_admin') {
        console.log('✅ WebsiteWrapper - User has automatic access');
        setSubscriptionStatus({ active: true, type: 'included' });
        setLoading(false);
        return;
      }

      // For agency agents, check subscription status
      if (user.role === 'agent' && (user.agency_id || user.agencyId)) {
        console.log('🔍 WebsiteWrapper - Agency agent, checking subscription');
        console.log('🔍 WebsiteWrapper - Subscription value type:', typeof user.website_subscription_active);
        console.log('🔍 WebsiteWrapper - Subscription value:', user.website_subscription_active);
        
        // Check if website_subscription_active is already in user object
        if (user.website_subscription_active === 1 || user.website_subscription_active === '1') {
          console.log('✅ WebsiteWrapper - Subscription active, granting access');
          setSubscriptionStatus({ active: true, type: 'subscribed' });
        } else {
          console.log('❌ WebsiteWrapper - No active subscription found');
          console.log('❌ WebsiteWrapper - Expected: 1, Got:', user.website_subscription_active);
          setSubscriptionStatus({ active: false, type: 'not_subscribed' });
        }
        setLoading(false);
        return;
      }

      // Default to no access
      console.log('❌ WebsiteWrapper - Default no access');
      setSubscriptionStatus({ active: false, type: 'no_access' });
      setLoading(false);

    } catch (err) {
      console.error('Error checking subscription status:', err);
      setError('Unable to check subscription status');
      setLoading(false);
    }
  };

  const handleSubscriptionSuccess = () => {
    // Show success message
    setShowSuccess(true);
    
    // Refresh subscription status and redirect after 3 seconds
    setTimeout(() => {
      checkSubscriptionStatus();
    }, 3000);
  };

  if (loading) {
    return (
      <div className="website-wrapper-loading">
        <div className="loading-content">
          <div className="loading-spinner">
            <i className="fas fa-spinner fa-spin"></i>
          </div>
          <p>Checking website access...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="website-wrapper-error">
        <div className="error-content">
          <i className="fas fa-exclamation-triangle"></i>
          <h3>Unable to Load Website Management</h3>
          <p>{error}</p>
          <button 
            className="btn-primary"
            onClick={checkSubscriptionStatus}
          >
            <i className="fas fa-refresh"></i>
            Try Again
          </button>
        </div>
      </div>
    );
  }

  // Show success message after subscription
  if (showSuccess) {
    // Scroll to top when success screen shows
    window.scrollTo({ top: 0, behavior: 'smooth' });
    
    return (
      <div className="subscription-success-wrapper">
        <div className="success-content">
          <div className="success-icon">
            <i className="fas fa-check-circle"></i>
          </div>
          <h2>Welcome to Your Website!</h2>
          <p>Your subscription has been activated successfully.</p>
          <p>Redirecting to your website management dashboard...</p>
          <div className="loading-spinner">
            <i className="fas fa-spinner fa-spin"></i>
          </div>
        </div>
      </div>
    );
  }

  // Route based on subscription status
  if (subscriptionStatus?.active) {
    return <WebsiteManagement />;
  } else {
    return (
      <WebsiteSubscription 
        onSubscriptionSuccess={handleSubscriptionSuccess}
        userRole={user.role}
      />
    );
  }
};

export default WebsiteWrapper;
